import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { SharedApplicationState } from '../shared-state';
import { OverviewPageCache, OverviewPageCacheState } from './overview-page-cache.entity';
import { overviewPageCacheAdapter } from './overview-page-cache.reducer';

export const getViewOptionsState: MemoizedSelector<
    object,
    OverviewPageCacheState,
    DefaultProjectorFn<OverviewPageCacheState>
> = createFeatureSelector<OverviewPageCacheState>('overviewPageCache');

const { selectEntities } = overviewPageCacheAdapter.getSelectors(getViewOptionsState);

export const selectFeature: (state: SharedApplicationState) => OverviewPageCacheState = (
    state: SharedApplicationState
) => state.overviewPageCache;

export function getOverviewPageCache(
    id: string
): MemoizedSelector<object, OverviewPageCache | undefined, DefaultProjectorFn<OverviewPageCache | undefined>> {
    return createSelector(selectEntities, (entries: Dictionary<OverviewPageCache>) => entries[id]);
}

export const overviewPageCacheSelector: MemoizedSelector<
    object,
    Dictionary<OverviewPageCache>,
    DefaultProjectorFn<Dictionary<OverviewPageCache>>
> = createSelector(selectEntities, (entries: Dictionary<OverviewPageCache>) => entries);
